//import "./wdyr";

import {FocusStyleManager} from "@blueprintjs/core";
import React from "react";
import ReactDOM from "react-dom";
import AppWithRouterAccess from "./AppWithRouterAccess";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import log from "loglevel";

FocusStyleManager.onlyShowFocusOnTabs();

// Append logger to window object for console access
(window as any).log = log;

ReactDOM.render(
  <React.StrictMode>
    <AppWithRouterAccess />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
